<template>
  <div>
    <v-layout class="app-form align-center">
      <v-flex xs2>
        <AppForm label="対象エリア" />
      </v-flex>
      <v-flex xs1>
        <v-btn @click="onClickTargetArea" icon small>
          <v-icon>edit</v-icon>
        </v-btn>
      </v-flex>
    </v-layout>
    <v-layout v-if="isAreaEmpty">
      <AppForm label="指定なし" />
    </v-layout>
    <div v-else>
      <v-btn @click="clearPrefectureOrCity" small class="all-clear-button">
        選択を解除
      </v-btn>
      <v-layout class="columns">
        <AppDeletableColumn
          :idsAndNames="idsAndNames"
          @onDelete="removePrefectureOrCity"
        />
      </v-layout>
    </div>
  </div>
</template>

<script>
import { TargetAreaTypes } from '@/models/CampaignOperation/Constants'

export default {
  name: 'TargetArea',
  props: {
    poiSearchForm: {
      type: Object,
      default: () => {},
    },
  },
  computed: {
    isAreaEmpty() {
      return (
        this.poiSearchForm.area.prefectureAreaObj.prefectureIds.length === 0 &&
        this.poiSearchForm.area.cityAreaObj.prefectures.length === 0
      )
    },
    isAreaChosenPrefecture() {
      return (
        this.poiSearchForm.administrativeDistrictType ===
        TargetAreaTypes.PREFECTURE
      )
    },
    idsAndNames() {
      if (this.isAreaChosenPrefecture) {
        return this.poiSearchForm.area.prefectureAreaObj.prefectureIdAndNames
      } else {
        return this.poiSearchForm.area.cityAreaObj.prefectures
          .map(prefecture => {
            return prefecture.cityIdAndNames.map(cityIdAndName => {
              return {
                id: cityIdAndName.id,
                name: prefecture.prefectureName + ' > ' + cityIdAndName.name,
              }
            })
          })
          .flat()
      }
    },
  },
  methods: {
    clearPrefectureOrCity() {
      this.poiSearchForm.area.clear(
        this.poiSearchForm.administrativeDistrictType,
      )
    },
    onClickTargetArea() {
      this.$emit('onClickTargetArea')
    },
    removePrefectureOrCity(id) {
      this.poiSearchForm.removePrefectureOrCity(id)
    },
  },
}
</script>

<style scoped>
.app-form {
  margin-top: 30px;
}
.columns {
  width: 300px;
  height: 150px;
  margin-left: 35px;
  margin-top: 10px;
}
.all-clear-button {
  margin-left: 250px;
}
</style>
